<template>

    <transition name="fade" v-if="timer > 0">
        <div class="alert box-shadow mb-2" :class="className" role="alert">
            <button type="button" data-dismiss="alert" aria-label="Close" class="close" @click="close">
                <span v-if="should_auto_close" class="loader">{{timer}}</span>
                <span aria-hidden="true">&times;</span>
            </button>
            <div :class="icon" class="pr-2"></div>
            <slot />
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'alert',

        props: {
            type: {required: false, default: 'success'},
            autoClose: {required: false, default: false},
        },

        data() {
            return {timer: 5}
        },

        computed: {
            className() {
                return 'alert-' + (this.type === 'error' ? 'danger' : this.type)
            },
            should_auto_close() {
                return this.type === 'success' || this.autoClose
            },
            icon() {
                return 'oi oi-' +( this.type === 'error' ? 'danger' : this.type)
            }
        },

        mounted() {
            if (this.should_auto_close) {
                setInterval(() => this.timer--, 1000)
            }
        },

        methods: {
            close() {
                this.timer = 0
            }
        }
    }
</script>

<style scoped>
    .alert {
        line-height: 200%;
    }
    .loader {
        font-size: 12px;
        line-height: 18px;
        border: 4px solid #f3f3f3;
        border-radius: 50%;
        border-top: 4px solid #3498db;
        width: 25px;
        height: 25px;
        -webkit-animation: spin 2s linear infinite;
        animation: spin 2s linear infinite;
        float: left;
        margin: 0 10px 0 0;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }


    @-webkit-keyframes spin {
        0% {
            -webkit-transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
        }
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
